import { SyntheticEvent, useCallback, useMemo, useRef, useState } from "react";
import CSSStyle from './index.module.css';
import React from "react";
import { FormattedMessage } from "react-intl";
import { AdyenPaymentEnhProps, AdyenPaymentError, AdyenPaymentResult, AdyenPaymentSessionData, DisplayFormatEnum, getMessage, JoinClassName, numberFormat, PaymentLocalization } from "../common";
import AdyenCreditCardEntryEnh from "../CreditCardEntry";
import { LOCAL } from "@fantuaneats/chowbus-web-stripe-payment";
import { ApplePaymentMethod } from "../ApplePayPaymentMethod";




export default function AdyenPaymentEnh(props: AdyenPaymentEnhProps) {
    const {
        local: currentLanguage,
        localization,
        paymentAmount,
        // getPaymentSession,
        // onBeforePaymentStart,
        // onPaymentComplete,
        onPaymentFailed,
        onUnExcepionError,
        // afterConfirmPayment,
        // config: {
        //     environment = 'live-us',
        //     clientKey: publicKey,
        // }
        loadingIndicator,

    } = props;
    // const [paymentMethodEnablFlags, setPaymentMethodEnablFlags] = useState<{ creditCardPayEnable: boolean; applePayEnable: boolean; } | null>({ creditCardPayEnable: true, applePayEnable: false, });
    // const [initError, setInitError] = useState<string>('');
    const [showCreditCardEntry, setShowCreditCardEntry] = useState(false);
    const [startApplyPayment, setStartApplyPayment] = useState(false);
    const ApplePayRef = useRef<{ sendPayRequest: () => void } | null>(null);
    const onCreditCardPayment = useCallback(() => {
        setShowCreditCardEntry(true);
        setStartApplyPayment(false);
    }, []);
    const onApplyPayPayment = useCallback(() => {
        setStartApplyPayment(true);
        setShowCreditCardEntry(false);
    }, []);

    const onCancelCreditCardPayment = useCallback(() => {
        setShowCreditCardEntry(false);
    }, []);


    const { creditCardPayEnable, applePayEnable } = useMemo(() => {
        let applyPayEnableOnEnv = false;
        // try {
        //     applyPayEnableOnEnv = !!(window as any).ApplePaySession && ApplePaySession.canMakePayments();
        // } catch (e) {
        //     applyPayEnableOnEnv = false;
        // }
        let paymentMethodEnablFlags = { creditCardPayEnable: true, applePayEnable: false, };

        if (paymentMethodEnablFlags) {
            return {
                ...paymentMethodEnablFlags,
                applePayEnable: paymentMethodEnablFlags.applePayEnable && applyPayEnableOnEnv,
            }
        } else {
            return {
                creditCardPayEnable: false,
                applePayEnable: false,
            }
        }
    }, []);

    const _onPaymentFailed_ = useCallback((resultCode: AdyenPaymentResult, sessionData: AdyenPaymentSessionData, message?: string) => {
        setShowCreditCardEntry(false);
        loadingIndicator && loadingIndicator(false);
        onPaymentFailed(resultCode, sessionData, message);
    }, [onPaymentFailed, loadingIndicator]);

    const _onUnExcepionError_ = useCallback((errorType: AdyenPaymentError, message?: string) => {
        setShowCreditCardEntry(false);
        loadingIndicator && loadingIndicator(false);
        onUnExcepionError(errorType, message);
    }, [onUnExcepionError, loadingIndicator]);

    return <React.Fragment>
        <div className={JoinClassName(CSSStyle.main,)}>
            {
                /* {
                    initError && <span className={JoinClassName(CSSStyle.aydenInitError)}>{initError}</span>
                } */
            }
            {
                <React.Fragment>
                    <div className={JoinClassName(CSSStyle.paymethodSection)} >
                        {/* 如果支持Apply，那么Appl显示优先，可以切换到Credit card支付方式 */}
                        {
                            applePayEnable && <ApplePayPaymentMethodChannel localization={localization} currentLanguage={currentLanguage as LOCAL} paymentAmount={paymentAmount} onApplyPayPayment={onApplyPayPayment} onSwitchToCreditCard={() => { }} />
                        }
                        {/* 如果不支持Apply，那么只显示Credit card支付, */}
                        {
                            !applePayEnable && creditCardPayEnable && <CreditCardPaymentMethodChannel localization={localization}
                                currentLanguage={currentLanguage as LOCAL} paymentAmount={paymentAmount}
                                onCreditCardPayment={onCreditCardPayment} />
                        }
                    </div>
                </React.Fragment>
            }
        </div>
        {/* credit card method */}
        {
            showCreditCardEntry && <AdyenCreditCardEntryEnh  {...props} onPaymentFailed={_onPaymentFailed_} onUnExcepionError={_onUnExcepionError_} onCancelCreditCardPayment={onCancelCreditCardPayment} />
        }
        {/* apple pay method */}
        {
            startApplyPayment && <ApplePaymentMethod  {...props} onPaymentFailed={_onPaymentFailed_} onUnExcepionError={_onUnExcepionError_} ref={ApplePayRef} />
        }
    </React.Fragment>
}


function ApplePayPaymentMethodChannel(props: {
    localization: PaymentLocalization;
    currentLanguage: LOCAL,
    paymentAmount: number;
    onApplyPayPayment: () => void;
    onSwitchToCreditCard: () => void;
}) {
    const { currentLanguage, paymentAmount, onApplyPayPayment, onSwitchToCreditCard } = props;
    return <React.Fragment>
        <div className={JoinClassName(CSSStyle.apply_pay_outer_container)}>
            <div className={JoinClassName(CSSStyle.apply_pay_container)}>
                <div onClick={onApplyPayPayment} className={JoinClassName(CSSStyle.apply_pay_button,
                    paymentAmount ? "" : CSSStyle.disable)}>

                    <div className={JoinClassName(CSSStyle.desc)}><FormattedMessage id="check_out_with_prefix" /></div>
                    <div className={JoinClassName(CSSStyle.apply_pay_icon)}></div>
                    <div className={JoinClassName(CSSStyle.desc)} style={currentLanguage === LOCAL.ZH ? { paddingRight: '2px' } : {}}><FormattedMessage id="check_out_with_suffix" /></div> • ${numberFormat((paymentAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2)}
                </div>
            </div>
            <div className={JoinClassName(CSSStyle.credit_card_pay_entry, paymentAmount ? "" : CSSStyle.disable)} onClick={onSwitchToCreditCard}>
                <FormattedMessage id="Enter_Card_Number_Manually" />
            </div>
        </div>

    </React.Fragment>
}


function CreditCardPaymentMethodChannel(props: {
    localization: PaymentLocalization;
    currentLanguage: LOCAL,
    paymentAmount: number;
    // onSwitchApplyPayPayment: () => void;
    onCreditCardPayment: () => void;
}) {
    const { paymentAmount, onCreditCardPayment, localization, currentLanguage } = props;
    return <React.Fragment>
        <div className={JoinClassName(CSSStyle.credit_payment_button_container)}>
            <div className={JoinClassName(CSSStyle.credit_payment_button, paymentAmount ? "paymentButton hasAmount"
                : "paymentButton")} onClick={onCreditCardPayment}>
                {/* <FormattedMessage id="confirm_and_pay_button_no_card" values={{ paymentAmount: numberFormat((paymentAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2) }}></FormattedMessage> */}

                {
                    getMessage(localization[currentLanguage]['credite_card_pay_button'], {
                        paymentAmount: `${numberFormat((paymentAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2)}`
                    })
                }
            </div>
        </div>
    </React.Fragment>
}

export function PaybuttonV2(props: {
    localization: PaymentLocalization;
    currentLanguage: LOCAL,
    paymentAmount: number;
    onClick: (event: SyntheticEvent) => void;
}) {
    const { paymentAmount, localization, currentLanguage, onClick } = props;
    return <React.Fragment>
        <div className={JoinClassName(CSSStyle.credit_payment_button_container)} onClick={onClick}>
            <div className={JoinClassName(CSSStyle.credit_payment_button, paymentAmount ? "paymentButton hasAmount"
                : "paymentButton")} >
                {
                    getMessage(localization[currentLanguage]['credite_card_pay_button'], {
                        paymentAmount: `${numberFormat((paymentAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2)}`
                    })
                }
            </div>
        </div>
    </React.Fragment>
}